import './Product.css';
import Placeholder from '../../assets/placeholder.svg'
import ProductCurve from '../../assets/dynamic/product-curve'
import Label from '../../components/Label'

import { Link } from 'react-router-dom';

function Product({ color, details, siblings }) {
  const materials = [
    details.materials.pearls.length ? `${details.materials.pearls.join(', ')} pearls` : null,
    details.materials.gemstones.length ? `${details.materials.gemstones.join(', ')} gemstones` : null,
    details.materials.beads.length ? `${details.materials.beads.join(', ')} beads` : null,
    details.materials.hardware.length ? `${details.materials.hardware.join(', ')} hardware` : null,
  ].filter(v => v).join(', ');

  return (
    <div className={`product page-container container bg bg-image-${color}`}>
      <div className="row">
        <div className="col-6">
          <div className="product-left center-children section">
            <div className="product-image-container">
              <ProductCurve color={color} />
              <img
                alt={`${details.category} from the ${details.collection} collection`}
                className="product-image"
                onError={(e) => e.target.src = Placeholder}
                src={`${process.env.PUBLIC_URL}/media/products/${details.category}-${details.collection}.jpeg`}
              />
              {/* TODO: Allow multiple photos */}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="product-right">
            <div className="section">
              <h1 className={`product-title text-color-${color}`}>{details.name}</h1>
              <span className={`balgend product-background-name text-color-${color}`}>{details.name}</span>
              <p>{details.description}</p>
              { siblings.length ? (
                <p>
                  To complete the ensemble, indulge in the matching{' '}
                  { siblings.map(((sibling, index) => {
                    return index === siblings.length - 1 ? (
                      <span key={`${sibling.name}-${sibling.category}`}>
                        {siblings.length > 1 ? ' or ' : null}
                        <Link to={`/${sibling.collection}/${sibling.category}`}>{sibling.category}</Link>.
                      </span>
                    ) : (
                      <span key={`${sibling.name}-${sibling.category}`}>
                        <Link to={`/${sibling.collection}/${sibling.category}`}>{sibling.category}</Link>,
                      </span>
                    );
                  })) }
                </p>
              ) : null}
            </div>
            <div className="section">
              <h2 className={`product-sub-header text-color-${color}`}>Details</h2>
              <p>
                Each Pafiume Jewelry product is handcrafted from natural materials, ensuring a unique and artisanal touch. Due to the inherent characteristics of these materials, variations in shape, size, and patina may occur, creating a distinctive charm that makes each piece truly one of a kind.
              </p>
              <Label title="Category" value={details.category} />
              <Label title="Length" value={details.length} />
              <Label title="Materials" value={materials} />
              <Label title="Colors" value={details.colors.join(', ')} />
              <Label title="Price" value={details.price ? `$${details.price}.00` : null} />
              <Label title="Circa" value={details.date} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Product;
